import { onMounted } from '@vue/composition-api'
import store from '@/store'

export default function useRegisterStoreModule(storeName, storeModule) {
  const registerIfNotRegistered = () => {
    if (!store.hasModule(storeName)) {
      store.registerModule(storeName, storeModule)
    }
  }
  registerIfNotRegistered()

  onMounted(() => {
    registerIfNotRegistered()
  })

  // onUnmounted(() => {
  //   if (store.hasModule(storeName)) store.unregisterModule(storeName)
  // })
}
